// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__rqQcG","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3JSXA"};